import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, Alert, DialogActions, Button, Typography } from '@mui/material';

export const IgnoreFiltersAcknowledgementDialog = ({ filtersPtr, intl }) => {
    return <Dialog open={filtersPtr.value.showIgnoredFilterDialog}
        maxWidth="xs"
        fullWidth
    // onClose={handleSyncCallbackDialogClose}
    >
        <DialogTitle sx={{ color: "deeppink" }}>
            Search All Claims
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                <Typography>
                    Search all Analyzed Claims ?
                </Typography>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={() => filtersPtr.update( prev => ({
                    ...prev,
                    showIgnoredFilterDialog:false,
                    ignoreAcknowledgement:true
                }))}
            >
                OK
            </Button>
            <Button
                onClick={()=> filtersPtr.update( prev => ({
                    ...prev,
                    showIgnoredFilterDialog:false,
                    searchTerm: "",
                }))}
            >
                Cancel
            </Button>
        </DialogActions>
    </Dialog>
}